import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { ArrowLeft2 } from "iconsax-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { SButton } from "../buttons/SButton";
import { useTranslation } from "react-i18next";
import { colCenter } from "../style/style";
const PageHeader = ({ title, subtitle, showBackButton = false, topActions, bottomActionButton, }) => {
    const theme = useTheme();
    const { t } = useTranslation("common");
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1);
    };
    // Make topActions buttons responsive (medium size on mobile)
    const renderResponsiveTopActions = () => {
        if (!topActions)
            return null;
        if (isMobile && React.isValidElement(topActions)) {
            return React.cloneElement(topActions, {
                size: "medium",
            });
        }
        return topActions;
    };
    // Render bottom action button for mobile (sticky at bottom)
    const renderMobileBottomButton = () => {
        if (!bottomActionButton)
            return null;
        return (React.createElement(Box, { sx: {
                position: "fixed",
                bottom: 68,
                left: 0,
                right: 0,
                bgcolor: "#F4F6F8",
                px: 2,
                py: 1.5,
                pb: 1,
                zIndex: 1000,
            } },
            React.createElement(SButton, { variant: bottomActionButton.variant || "contained", color: bottomActionButton.color || "primary", onClick: bottomActionButton.onClick, size: "small", fullWidth: true, disabled: bottomActionButton.disabled || bottomActionButton.loading, startIcon: bottomActionButton.startIcon, endIcon: bottomActionButton.endIcon, sx: { fontWeight: 500 } }, bottomActionButton.loading
                ? t("status.loading")
                : bottomActionButton.label)));
    };
    // Render bottom action button for desktop (fixed at bottom right)
    const renderDesktopBottomButton = () => {
        if (!bottomActionButton)
            return null;
        return (React.createElement(Box, { sx: {
                position: "fixed",
                bottom: isSmallScreen ? 80 : 16,
                right: 36,
                zIndex: 1000,
            } },
            React.createElement(SButton, { variant: bottomActionButton.variant || "contained", color: bottomActionButton.color || "primary", onClick: bottomActionButton.onClick, size: bottomActionButton.size, disabled: bottomActionButton.disabled || bottomActionButton.loading, startIcon: bottomActionButton.startIcon, endIcon: bottomActionButton.endIcon, sx: { fontWeight: 500 } }, bottomActionButton.loading
                ? t("status.loading")
                : bottomActionButton.label)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                pb: 0.5,
                pr: { xs: 1.5, sm: 2, lg: 3 },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
            } },
            React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1, flex: 1 } },
                showBackButton && (React.createElement(SButton, { variant: "soft", size: "large", responsiveIcon: true, startIcon: React.createElement(ArrowLeft2, { size: 16 }), onClick: handleGoBack, iconButtonBorderRadius: '50%' }, t("actions.goBack"))),
                React.createElement(Box, { sx: { flex: 1 } },
                    React.createElement(Box, { sx: Object.assign(Object.assign({}, colCenter), { gap: 1 }) },
                        isSmallScreen && !showBackButton && (React.createElement(Box, { component: "img", 
                            // sx={{ lg: "block", xl: "none" }}
                            src: "/assets/mobile-logo.svg", alt: "Mobile Logo" })),
                        React.createElement(Typography, { variant: "h2", lineHeight: 1, component: "h2", color: "primary.darker" }, title)),
                    subtitle && (React.createElement(Typography, { variant: "body1", color: "text.secondary", sx: { mt: 0.5 } }, subtitle)))),
            topActions && !(isMobile && !bottomActionButton) && (React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    flexShrink: 0,
                } }, renderResponsiveTopActions()))),
        !isMobile && renderDesktopBottomButton(),
        isMobile && renderMobileBottomButton(),
        isMobile && topActions && !bottomActionButton && (React.createElement(Box, { sx: {
                position: "fixed",
                bottom: 68,
                left: 0,
                right: 0,
                bgcolor: "#F4F6F8",
                px: 2,
                py: 1.5,
                pb: 1,
                zIndex: 1000,
            } }, React.isValidElement(topActions)
            ? React.cloneElement(topActions, {
                size: "small",
                fullWidth: true,
            })
            : topActions))));
};
export default PageHeader;
